import { Routes } from '@angular/router';
import { MainLayoutResolver } from '@layout/main-layout/main-layout-resolver';
import { AuthGuard } from './core/guards/auth.guard';

export const app_routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/login/login.routes').then(({ login_routes }) => login_routes),
  },
  {
    resolve: {
      Api: MainLayoutResolver,
    },
    path: '',
    loadChildren: () =>
      import('./layout/main-layout/main-layout.routes').then(
        ({ main_layout_routes }) => main_layout_routes,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'help-center',
    loadChildren: () =>
      import('./layout/public-layout/public-layout.routes').then(
        ({ page_public_routes }) => page_public_routes,
      ),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
